SubtitleTooltip = window.SubtitleTooltip ?={}

SubtitleTooltip.init = (payload, done) ->
  $ ->
    $("#show-all-locations-subtitle").click ->
      subtitletooltip = $("#subtitle-locations-tooltip")
      subtitletooltip.css('opacity', 0)
      subtitletooltip.hide()

    done()


module.exports = SubtitleTooltip
